import { render } from "./RewardsPage.vue?vue&type=template&id=235afef4&scoped=true"
import script from "./RewardsPage.vue?vue&type=script&lang=js"
export * from "./RewardsPage.vue?vue&type=script&lang=js"

import "./RewardsPage.vue?vue&type=style&index=0&id=235afef4&scoped=true&lang=css"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-235afef4"]])

export default __exports__